import { BrandVariants, createLightTheme, Theme } from "@fluentui/react-components";

// Brand ramp built around the LOX24 logo red (#C91212). Shade 80 is the primary
// brand color used for buttons, selected tabs, links, and focus states.
const lox24Brand: BrandVariants = {
  10: "#1F0202",
  20: "#360404",
  30: "#4C0606",
  40: "#620808",
  50: "#790A0A",
  60: "#900C0C",
  70: "#A80F0F",
  80: "#C91212", // LOX24 red — primary
  90: "#D62F2F",
  100: "#E04A4A",
  110: "#E96565",
  120: "#F08080",
  130: "#F59B9B",
  140: "#F9B6B6",
  150: "#FCD1D1",
  160: "#FDEBEB",
};

export const lox24LightTheme: Theme = createLightTheme(lox24Brand);
